import Vue from "vue";
import App from "./App.vue";
import router from './utils/router';
import store from "./store";
import axios from './utils/vueAxios';
import sv from './utils/staticVariables'; //引入静态变量


// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)


import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

// 确保在 Vue 初始化之后引入 globalComponents.js
import './components/globalComponents.js';

Vue.config.productionTip = false;

Vue.prototype.$ajax = axios;
Vue.prototype.sv = sv;

new Vue({
  router,
  store,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
